import { useState } from "react";

import styled from "styled-components";

import { useUserData } from "Flocknote/apiHooks";

import { useOtherNetworks } from "CrossFeatureComponents/MemberToolbar/API/queryHooks";
import { useUserButtonRef } from "NavBar/navBarStore";
import { useIsUserButtonFlashing } from "NavBar/stateHooks";

import FnrButtonPopper from "UI/FnrButtonPopper";
import FnrNetworkPhoto from "UI/FnrNetworkPhoto";
import FnrTypography from "UI/FnrTypography";

import { useShowBackgroundManagerButton } from "Utilities/Hooks/useBackgroundManagerHeight";
import dynMaxWidth from "Utilities/interpolations/dynMaxWidth";

import ButtonSizer from "../ButtonSizer";
import PopperButton from "../PopperButton";

import PopperContent from "./PopperContent";

const UserButton = () => {
  const [{ photoUrl, fname }] = useUserData();
  useOtherNetworks(); // prefetch this data
  const [closeTrigger, setCloseTrigger] = useState({});
  const showBackgrounManagerButton = useShowBackgroundManagerButton();
  const userButtonRef = useUserButtonRef();
  const isFlashing = useIsUserButtonFlashing();

  return (
    <FnrButtonPopper
      ref={userButtonRef}
      content={<PopperContent setCloseTrigger={setCloseTrigger} />}
      Button={PopperButton}
      buttonProps={{
        "data-cy": "NavBar_UserMenu",
        color: "#ffffff0",
        isFlashing: isFlashing,
      }}
      closeTrigger={closeTrigger}
      autoFocus
    >
      <ButtonSizer>
        <Wrapper>
          <FnrNetworkPhoto src={photoUrl} noBorder />
          <SFnrTypography
            data-cy="UserButton_UserName"
            $delayTransition={!showBackgrounManagerButton}
            $maxWidth={showBackgrounManagerButton ? 60 : 104}
            color="textLight"
          >
            {fname}
          </SFnrTypography>
        </Wrapper>
      </ButtonSizer>
    </FnrButtonPopper>
  );
};

const SFnrTypography = styled(FnrTypography)`
  overflow: hidden;
  ${dynMaxWidth}
  white-space: nowrap;
  text-overflow: ellipsis;
  transition: max-width 300ms
    ${({ $delayTransition }) => ($delayTransition ? "300ms" : "")} ease-in-out;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 0 8px 0 4px;
`;

export default UserButton;
